import { registerLocaleData } from '@angular/common';
import localEs from '@angular/common/locales/es';

/*MODULOS*/
import { BrowserModule } from '@angular/platform-browser';
import { NgModule, LOCALE_ID} from '@angular/core';
import { FormsModule } from '@angular/forms';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { AppRoutingModule } from './app-routing.module';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';

import { AngularFireModule } from '@angular/fire';
import { AngularFireAuthModule } from '@angular/fire/auth';


/*PLUGINS*/
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

/*COMPONENTES*/
import { AppComponent } from './app.component';

/* MÓDULOS PERSONALIZADOS*/
import { PipesModule } from './pipes/pipes.module';
import { ComponentsModule } from './pages/main/components/components.module';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { environment } from '../environments/environment';
import { HelpModalModule } from './pages/main/components/help-modal/help-modal.module';
import { AppInterceptor } from './app.interceptor';




registerLocaleData(localEs);

@NgModule({
	declarations: [
		AppComponent
	],
	imports: [
		BrowserModule,
		AppRoutingModule,
		HttpClientModule,
		FormsModule,
		NgbModule,
		PipesModule,
		ComponentsModule,
		BrowserAnimationsModule,
		HelpModalModule,
		NgxSkeletonLoaderModule.forRoot({ animation: 'pulse', loadingText: 'This item is actually loading...' }),
		AngularFireModule.initializeApp(environment.FIREBASE_CONFIG),
		AngularFireAuthModule
	],
	providers: [
		{
			provide: LOCALE_ID,
			useValue: 'es-MX'
		},
		{
			provide : HTTP_INTERCEPTORS,
			useClass: AppInterceptor,	
			multi   : true
		},
	],
	bootstrap: [AppComponent]
})
export class AppModule { }
